// The layout scrolls the window back to the top after every route change
// (see components/scroll-top/ScrollTop.tsx), animating documentElement
// .scrollTop to 0 over ~600ms. A page that restores its own scroll position --
// a table returning the user to the row they came from -- has to be able to
// opt out of that one jump, or the animation overwrites its scroll frame by
// frame and the page ends up at the top anyway.
//
// Ask for it before the route change settles.

// A short window rather than a single flag: one navigation can trigger the
// jump more than once (a redirect, a re-render of the layout), and all of
// those belong to the same arrival.
const SUPPRESSION_WINDOW_MS = 1500

let suppressedUntil = 0

export const suppressScrollTopOnce = () => {
  suppressedUntil = Date.now() + SUPPRESSION_WINDOW_MS
}

export const consumeScrollTopSuppression = () => Date.now() < suppressedUntil
